import { useState } from "react";
import { pad, useFreeCountdown } from "@/lib/launchOffer";
import { Gift, X } from "lucide-react";

const DISMISS_KEY = "cck_free_launch_banner_dismissed";
// Shown to everyone while payments are switched off in Admin → Settings.
export const FreeAccessBanner = () => {
  const { freeMode, left, label } = useFreeCountdown();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });
  if (!freeMode || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* storage disabled */ }
  };

  return (
    <div className="bg-sage-light/70 border-b border-sage/20 animate-in fade-in slide-in-from-top-2 duration-500" data-testid="free-access-banner">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <span className="shrink-0 w-7 h-7 rounded-full bg-terracotta-light flex items-center justify-center">
          <Gift className="w-4 h-4 text-terracotta-dark" />
        </span>
        <p className="flex-1 text-sm text-forest" data-testid="free-access-banner-text">
          <strong className="font-bold">
            {left ? `Compass Kids is free until ${label}.` : "Compass Kids is free during our launch period."}
          </strong>{" "}
          <span className="text-forest/75">Enjoy full access, no payment needed!</span>
        </p>
        {left && (
          <span
            className="shrink-0 inline-flex items-center gap-1 rounded-full bg-terracotta-dark text-white text-xs font-bold px-3 py-1 tabular-nums whitespace-nowrap"
            aria-label={`${left.d} days ${left.h} hours ${left.m} minutes left`}
            data-testid="free-access-countdown"
          >
            {left.d}d {pad(left.h)}h {pad(left.m)}m left
          </span>
        )}
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss free access banner"
          className="shrink-0 p-1.5 rounded-full text-forest/50 hover:text-forest hover:bg-white/60 transition-colors"
          data-testid="free-access-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
